import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import { ConfigNav, Container } from './styled';
import SmartAssessmentPageHeader from './SmartAssessmentPageHeader';
import GeneralInfoTabCardViews from './GeneralInfoTabCardViews';
import TransactionInformatoinTab from './TransactionInformatoinTab';
import ScoreExplainability from '../../tmCommon/ScoreExplainability';
import { hasAttributeValue, hasResourceOperation } from '../../../util';
import { ITEM_OPERATIONS, trmResources } from '../../../util/GlobalConstant';
import AlertHistoryPrevention from '../../tmCommon/components/AlertHistory/AlertHistoryPrevention';
import {
  clearAMLSCommonUnifiedAlerts,
  getAMLSCommonAlertPartyIdentity
} from '../../../redux/actions/common';
import { connect } from 'react-redux';

const { TabPane } = Tabs;

const SmartAssessment = ({
  match,
  alertId: cmAlertId,
  authentication,
  clearUnifiedAlertsData,
  apiActions,
  alertPartyIdentity,
  alertMetaSuffix
}) => {
  const [tab, setTab] = useState('1');
  const alertId = match?.params?.alertId || cmAlertId;
  const isFromCM = !!cmAlertId;
  const isPrevention =
    isFromCM ||
    hasAttributeValue(
      authentication,
      trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
      '24'
    );

  let VIEW_ACCESS_TABS =
    isFromCM ||
    hasResourceOperation(
      authentication,
      trmResources.APP_3_RESOURCE_UI_AMLS_TM_ALERT_DETAILS,
      ITEM_OPERATIONS.READ
    );

  useEffect(() => {
    if (alertId) {
      clearUnifiedAlertsData();
      if (isPrevention) {
        alertId && apiActions({ alertId, isPrevention });
      } else {
        alertId && apiActions({ alertId });
      }
    }
  }, [alertId]);

  const handleGraphClick = () => {
    setTab('3');
  };

  return (
    <Container>
      <SmartAssessmentPageHeader
        isPrevention={isPrevention}
        alertId={alertId}
        isFromCM={isFromCM}
        alertMetaSuffix={alertMetaSuffix}
      />
      <ConfigNav>
        <Tabs
          activeKey={tab}
          onChange={(activeKey) => {
            setTab(activeKey);
          }}>
          {VIEW_ACCESS_TABS && (
            <>
              <TabPane tab="General Information" key="1">
                <GeneralInfoTabCardViews
                  isPrevention={isPrevention}
                  alertId={alertId}
                  alertPartyIdentity={alertPartyIdentity}
                  handleGraphClick={handleGraphClick}
                />
              </TabPane>
              <TabPane tab="Transaction Information" key="2">
                <TransactionInformatoinTab
                  isPrevention={isPrevention}
                  alertId={alertId}
                  isSmartAssessment={isPrevention}
                />
              </TabPane>
              <TabPane
                tab={isPrevention ? 'Explanation' : 'Score explanation'}
                key="3">
                <ScoreExplainability
                  isPrevention={isPrevention}
                  alertId={alertId}
                />
              </TabPane>
              {isPrevention && (
                <TabPane tab="Alert History" key="4">
                  <AlertHistoryPrevention
                    alertPartyIdentity={alertPartyIdentity}
                    isFromCM={isFromCM}
                  />
                </TabPane>
              )}
            </>
          )}
        </Tabs>
      </ConfigNav>
    </Container>
  );
};

SmartAssessment.propTypes = {
  match: PropTypes.object,
  alertId: PropTypes.string,
  alertMetaSuffix: PropTypes.element
};

const mapStateToProps = (state) => {
  const { alertPartyIdentity = {} } = state.amlsCommon;
  return {
    alertPartyIdentity,
    authentication: state.authentication
  };
};

const mapDispatchToProps = (dispatch) => ({
  apiActions: (alertId) => dispatch(getAMLSCommonAlertPartyIdentity(alertId)),
  clearUnifiedAlertsData: () => dispatch(clearAMLSCommonUnifiedAlerts())
});

export default connect(mapStateToProps, mapDispatchToProps)(SmartAssessment);
